import { ERentTime, IJsonQuery } from '@cian/api-models/common/json_query';

export enum FDealType {
  Unexpected   = 0, // Do not use
  Sale         = 1 << 0,
  RentLongterm = 1 << 1,
  RentDaily    = 1 << 2,
  Rent         = RentLongterm | RentDaily,
  Any          = Sale | Rent,
}

export function getDealType(jsonQuery: IJsonQuery): FDealType {
  const type = jsonQuery._type;
  const rentTime = jsonQuery.for_day && jsonQuery.for_day.value;

  if (!type) {
    return FDealType.Unexpected;
  }

  if (type.endsWith('sale')) {
    return FDealType.Sale;
  }

  if (type.endsWith('rent')) {
    if (rentTime === ERentTime.NotDaily) {
      return FDealType.RentLongterm;
    } else if (rentTime === ERentTime.Daily) {
      return FDealType.RentDaily;
    }

    return FDealType.Rent;
  }

  return FDealType.Unexpected;
}
